import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import { client } from '../../../utils/apolloClient';

const initialState = {
  dealerRefundHistoryData:[],
    dealerRefundHistoryDataLoaded:false,
    errorInGettingDealerRefundeHistroyData:false,
    dealerRefundHistoryDataLoading:false

};
export const getDealerRefundHistory = createAsyncThunk(
  'getDealerRefundHistory',
  async ({orgIds,startDate,endDate,token}) => {
    let response = await client.authorizeRequest({
      method: 'GET',
      url: `${environmentURLs.REACT_APP_PAYMENT_SERVICE}/report/dealer-purchase?listType=Refund&orgIds=${orgIds}&startDate=${startDate}&endDate=${endDate}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
);

export const dealerRefundHistory= createSlice({
  name: 'dealerRefundHistory',
  initialState,
  reducers: {},
  extraReducers: {
    [getDealerRefundHistory.fulfilled]: (state, action) => {
    state.dealerRefundHistoryData = action.payload;
    state.dealerRefundHistoryDataLoaded = true;
    state.dealerRefundHistoryDataLoading = false;
    state.errorInGettingDealerRefundeHistroyData=false;
    },
    [getDealerRefundHistory.pending]: (state, action) => {
    state.dealerRefundHistoryDataLoaded = false;
    state.dealerRefundHistoryDataLoading = true;
    state.errorInGettingDealerRefundeHistroyData=false;
    },
    [getDealerRefundHistory.rejected]: (state, action) => {
    state.errorInGettingDealerRefundeHistroyData = true;
    state.dealerRefundHistoryDataLoaded = false;
    state.dealerRefundHistoryData = [];
    state.dealerRefundHistoryDataLoading = false;
    }
  }
});

export default dealerRefundHistory.reducer;